<script setup lang="ts">
useHead({
  title: "Шарунстор — Публичная оферта.",
  meta: [
    {
      name: "description",
      content: "Ознакомьтесь с офертой в Шарунстор",
    },
    {
      name: "keywords",
      content: "Публичная оферта",
    },
  ],
});
import Breadcrumbs from "~/components/Section/Breadcrumbs.vue";
import Cookie from "~/components/Section/Cookie.vue";
import Footer from "~/components/System/Footer.vue";

const breadcrumbs = ref([
  { title: "Главная", url: "/" },
  { title: "Публичная оферта" },
]);
</script>

<template>
  <main class="main">
    <section class="content">
      <Breadcrumbs :breadcrumbs="breadcrumbs" />
      <div class="container">
        <h1>Публичная оферта о заключении договора розничной купли-продажи</h1>

        <p>
          Настоящий документ является официальным предложением Индивидуального
          предпринимателя Шарун М.А. и/или третьих лиц – продавцов, размещающих
          товары на платформе Шарунстор, заключить договор розничной
          купли-продажи на изложенных ниже условиях.
        </p>

        <h2>1. Термины и определения</h2>

        <p>
          <strong>Платформа (Шарунстор)</strong> – интернет-сайт, посредством
          которого осуществляется размещение и продажа товаров.
        </p>

        <p>
          <strong>Продавец</strong> – Индивидуальный предприниматель Шарун М.А.
          или третье лицо (бренд, поставщик), информация о котором указана в
          карточке соответствующего товара.
        </p>

        <p>
          <strong>Покупатель</strong> – физическое лицо, приобретающее товар для
          личных, семейных, домашних и иных нужд, не связанных с осуществлением
          предпринимательской деятельности.
        </p>

        <p>
          <strong>Заказ</strong> – оформленный Покупателем запрос на
          приобретение товара.
        </p>

        <h2>2. Статус Платформы</h2>

        <p>
          Шарунстор является информационной платформой, предоставляющей
          возможность приобретения товаров как у Индивидуального предпринимателя
          Шарун М.А., так и у третьих лиц – продавцов.
        </p>

        <p>
          В случае если продавцом товара является третье лицо, Шарунстор не
          является стороной договора купли-продажи, если иное прямо не указано в
          карточке товара.
        </p>

        <h2>3. Предмет договора</h2>

        <p>
          Продавец обязуется передать в собственность Покупателю товар, а
          Покупатель обязуется оплатить и принять товар на условиях настоящей
          оферты.
        </p>

        <h2>4. Порядок заключения договора</h2>

        <p>
          Договор считается заключенным с момента подтверждения заказа и
          направления Покупателю соответствующего уведомления.
        </p>

        <p>
          Оформление заказа означает полное и безоговорочное принятие
          Покупателем условий настоящей оферты.
        </p>

        <h2>5. Цена и порядок оплаты</h2>

        <p>Цена товара указывается в карточке товара.</p>

        <p>Оплата осуществляется способами, указанными на Платформе.</p>

        <p>
          В случае если денежные средства принимаются Шарунстор в пользу
          третьего лица – продавца, Шарунстор действует в качестве агента по
          приему платежей.
        </p>

        <h2>6. Доставка</h2>

        <p>
          Доставка товара осуществляется со склада ИП Шарун М.А. или
          непосредственно продавцом.
        </p>

        <p>
          Сроки и стоимость доставки определяются отдельно по каждому товару и
          доводятся до сведения Покупателя при оформлении заказа.
        </p>

        <p>
          Стоимость доставки оплачивается Покупателем, если иное не
          предусмотрено условиями конкретного продавца.
        </p>

        <h2>7. Переход риска</h2>

        <p>
          Риск случайной гибели или повреждения товара переходит к Покупателю с
          момента передачи товара.
        </p>

        <h2>8. Возврат товара</h2>

        <p>
          Возврат товара осуществляется в порядке, предусмотренном
          законодательством Российской Федерации, в том числе Законом РФ «О
          защите прав потребителей».
        </p>

        <p>
          Если продавцом товара является третье лицо, требования о возврате,
          замене или устранении недостатков предъявляются соответствующему
          продавцу. Шарунстор оказывает информационное содействие в передаче
          претензии.
        </p>

        <h2>9. Ответственность</h2>

        <p>
          Стороны несут ответственность в соответствии с законодательством
          Российской Федерации.
        </p>

        <p>
          Шарунстор не несет ответственности за действия или бездействие
          третьих лиц – продавцов, за исключением случаев, прямо предусмотренных
          законом.
        </p>

        <h2>10. Персональные данные</h2>

        <p>
          Обработка персональных данных осуществляется в соответствии с
          Политикой конфиденциальности.
        </p>

        <h2>11. Заключительные положения</h2>

        <p>
          Настоящая оферта может быть изменена в одностороннем порядке.
          Изменения вступают в силу с момента публикации на сайте.
        </p>
        <h2>12. Цифровые товары</h2>

        <p>
          Под цифровыми товарами понимаются товары, предоставляемые Покупателю в
          электронном виде, включая, но не ограничиваясь: цифровыми продуктами,
          программным обеспечением, доступом к онлайн-сервисам и контенту.
        </p>

        <p>
          Доступ к цифровому товару предоставляется после полной оплаты и/или
          активации через личный кабинет или иные механизмы, указанные на
          платформе.
        </p>

        <p>
          Покупатель заранее уведомлен о том, что цифровой товар не подлежит
          возврату или обмену после предоставления доступа, если иное не
          установлено законодательством.
        </p>

        <p>
          Шарунстор и/или Продавец не несут ответственности за временные
          технические сбои, перебои в работе платформы или доступ к интернету,
          если они не вызваны умышленными действиями сторон.
        </p>

        <p>
          Использование цифрового товара регулируется лицензионными условиями,
          опубликованными на платформе.
        </p>
      </div>
    </section>
  </main>

  <Cookie />
</template>

<style scoped></style>
